const DATA_TEST_REGEXP = /^data-test-/;
const DATA_AND_ARIA_REGEXP = /^(data|aria)-/;
function excludeProps(props, regexp) {
    return Object.keys(props)
        .filter(prop => !prop.match(regexp))
        .reduce((nextProps, prop) => (Object.assign(Object.assign({}, nextProps), { [prop]: props[prop] })), {});
}
function extractProps(props, regex) {
    return Object.keys(props).reduce((nextProps, prop) => {
        if (prop.match(regex))
            nextProps[prop] = props[prop];
        return nextProps;
    }, {});
}
export function excludeSupportProps(props) {
    return excludeProps(props, DATA_AND_ARIA_REGEXP);
}
export function extractDataTestProps(props) {
    return extractProps(props, DATA_TEST_REGEXP);
}
export function extractSupportProps(props) {
    return extractProps(props, DATA_AND_ARIA_REGEXP);
}
